<label
  nz-checkbox
  [ngModel]="
    timelineModalFilterService.displayQualifiedWorkingTimeStaff$ | async
  "
  (ngModelChange)="qualifiedWorkingTimeStaffChanged($event)"
>
  {{
    'page.staff_assignment.filters.include_only_working_time_staff' | translate
  }}
</label>
